const trackIp = (buttonName) => {
    fetch('/track-ip', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        },
        body: JSON.stringify({ button_name: buttonName })
    }).catch(error => console.error('IP tracking error:', error));
};

export default trackIp;